var exports = {
  "phone": "xa15a2ab7--2fd6c7--phone",
  "phone-link": "xa15a2ab7--2fd6c7--phone-link",
  "row": "xa15a2ab7--2fd6c7--row",
  "phone-size-xxs": "xa15a2ab7--2fd6c7--phone-size-xxs",
  "phone-size-xs": "xa15a2ab7--2fd6c7--phone-size-xs",
  "phone-size-s": "xa15a2ab7--2fd6c7--phone-size-s",
  "phone-size-m": "xa15a2ab7--2fd6c7--phone-size-m",
  "phone-qrcode": "xa15a2ab7--2fd6c7--phone-qrcode",
};

module.exports = exports;
